import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _jsx from "@babel/runtime/helpers/jsx";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo } from 'react';
import * as icons from 'assets/icons';
import { jsx as _jsx2 } from "react/jsx-runtime";
var spriteFilename = "".concat(process.env.APP_ASSETS_PUBLIC_PATH, "sprite.").concat(process.env.APP_VERSION, ".svg");
var Icon = /*#__PURE__*/memo(function (_ref) {
  var name = _ref.name,
      props = _objectWithoutProperties(_ref, _excluded);

  var icon = icons[name];

  if (!icon) {
    return null;
  }

  return /*#__PURE__*/_jsx2("svg", _objectSpread(_objectSpread({
    viewBox: icon["default"].viewBox
  }, props), {}, {
    children: /*#__PURE__*/_jsx("use", {
      xlinkHref: "".concat(spriteFilename, "#").concat(icon["default"].id)
    })
  }));
});
Icon.defaultProps = {
  name: ''
};
export default Icon;